module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reset-password/reset-password.component.scss
// module id = ./src/app/reset-password/reset-password.component.scss
// module chunks = main